import { trackGoogleAnalytics } from '@common/util'

const iframe = document.querySelector('iframe[src*="html5-player.libsyn.com"]')

if (iframe) {
  const handlePlayerStart = (e) => {
    if (e.origin && e.origin === 'https://html5-player.libsyn.com' && e.data) {
      const timestamp = e.data
      const expectedDataFormat = /^\d{2}:\d{2}:\d{2}/

      const episodeName = iframe.dataset.title

      if (typeof timestamp === 'string' && expectedDataFormat.test(timestamp)) {
        trackGoogleAnalytics({
          event: 'podcast_episode_play',
          podcast_episode: episodeName,
        })

        window.removeEventListener('message', handlePlayerStart)
      }
    }
  }

  window.addEventListener('message', handlePlayerStart)
}
